<template>
  <div v-if="model">
    <div class="teachin-section" :class="`teachin-section-${name} ${active? 'teachin-section__active': ''}`">
      <div class="teachin-section__steps" v-if="model.steps && steps.length > 0">
        <draggable v-model="model.steps" v-bind="dragOptions" :move="onMove">
          <TeachinStep :step="step" :order="index" v-for="(step, index) in model.steps" :key="index" 
          :selected="selectedStep && selectedStep.name === step.name"
          @toggleSelected="toggleSelected(step)"/>
    </draggable>
    </div>
    <div class="teachin-section__details">
      <TeachinStepDetails :step="selectedStep" @syncModel="syncStepModel"/>
    </div>
  </div>  
  </div>
  
</template>

<script>
import { cloneDeep, isEqual } from 'lodash';
import TeachinStep from './TeachinStep.vue';
import TeachinStepDetails from './TeachinStepDetails.vue';
import draggable from 'vuedraggable'

  export default {
    name: 'TeachinSection',
    components: {TeachinStep,TeachinStepDetails, draggable},
    props:{
      section: {
        type: Object,
      }
    },
    created(){
    },
    data(){
      return {
        model: null,
        selectedStep: null
      };
    },
    computed: {
      dragOptions() {
        return {
          animation: 0,
          group: "steps",
          disabled: !this.model.sortSteps,
        };
      },
      name(){
        if(!this.model || !this.model.name) return '';
        return this.model.name;
      },
      active(){
        if(!this.model) return false;
        return this.model.active;
      },
      steps(){
        if(!this.model || !this.model.steps) return [];
        return this.model.steps;
      }
    },
    watch:{
      section: {
        handler(element, oldElement){
          this.init();
          if(!oldElement || element.name === oldElement.name)return;
          this.selectedStep = null;
        },
        deep: true,
        immediate: true
      },
      model:{
        handler(value){
          if(isEqual(value, this.section)) return;
          this.$emit('syncSection', cloneDeep(value));
        },
        deep: true
      }
    },
    methods:{
      init(){
        this.model = cloneDeep(this.section);
      },
      toggleSelected(step){
        if(this.selectedStep && step.name === this.selectedStep.name){
          this.selectedStep = null;
        }else{
          this.selectedStep = cloneDeep(step);
        }
      },
      syncStepModel(model){
        if(!model || !model.name) return;
        if(!this.model || !this.model.steps) throw Error('Missing required param');
        const index = this.model.steps.findIndex((el) => el.name === model.name);
        if(index === -1) throw Error('Selected step cannot be found');
        this.model.steps[index] = cloneDeep(model);
        this.selectedStep = cloneDeep(model);
        this.$emit('syncSection',cloneDeep(this.model));
      },
      onMove({ relatedContext, draggedContext }) {
        const relatedElement = relatedContext.element;
        const draggedElement = draggedContext.element;
        return (
          (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
        );
      }
      
    }
  }
</script>

<style lang="scss" scoped>
  .teachin-section{
    width: 100%;
    margin-top: 1em;
    display: flex;
    @media (max-width: 650px) {
      flex-wrap: wrap;
    }

    &__title{
      display: flex;
      flex-wrap: wrap;
      color: #1B99A7;
      font-family: Arial, sans-serif;
      font-size: 14px;
      line-height: 16.1px;
      font-weight: 700;
    }

    &__active{

    }

    &__details{
      display: flex;
      width: 325px;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      background-color: #f1f1f1;
      margin: 0;
      padding: 0;
      @media (max-width: 650px) {
        width: 100%;
        min-height: 100px;
      } 
    }

    &__steps{
      flex: 1;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: stretch;
      justify-content: stretch;
      & > div{
        display: flex;
        border: 1px solid #e5e5e5;
        height: 100%;
        flex-wrap: wrap;
        @media (max-width: 650px) {
            justify-content: center;
        }

      }
    }
  }
</style>
